<template>
  <div class="submit-form-container">
    <div class="form-informations">
      <div class="form-header">
        <img :src="header" />
      </div>
      <div class="meeting-contact">
        <h3>| 活动须知 |</h3>
        <div class="contact-info" v-html="summary">
          <!-- <div>
            随着全球赴日旅游人数迅猛增长，日本酒店供不应求，仅2020年酒店缺口过万间，未来十年随着奥运会、世博会等大型项目在日举办，日本旅游业也会不断升温，入境旅游者人数超六千万人，酒店缺口也将持续扩大，日本酒店业投资正当其时。1月4日在深圳举办2020年日本酒店投资机遇分享会，活动特邀数位海内外酒店业资深大咖深度把脉，助投资者抓住日本酒店行业的“戴维斯双击”投资机遇。
          </div>
          <div>
            为了您能顺利通过审核参加活动，请按要求上传名片并填写真实信息。格隆汇承诺参会信息仅用于本次活动联络需求，绝不对外公开
          </div>
          <div>
            我们会尽快审核您的报名信息，并以短信的方式告知您报名结果，请耐心等待。
          </div>
          <div>若您在报名期间有任何疑问，请联系格隆汇商务部。</div>
          <div>
            Tel：‭0755-86533750‬（分机号803） ，电邮：activity@gelonghui.com
          </div> -->
        </div>
      </div>
      <div class="data-form">
        <label for="phone">
          手机
          <span class="data-form-required">*</span>
        </label>
        <div class="phone-box">
          <el-input placeholder="仅支持香港(8位)和大陆手机号码(11位)" v-model.trim="form.phone" size="medium" />
          <div class="submit-button-phone">
            <button type="button" @click="gtPost" :disabled="false" v-if="isSendCode !== 1 && isSendCode !== 4">
              {{ isSendCode === 2 ? "重新" : "" }}获取验证码
            </button>
            <button type="button" :disabled="true" v-if="isSendCode === 1">
              {{ reTime }}后可重新获取
            </button>
          </div>
        </div>
        <label for="code">
          验证码
          <span class="data-form-required">*</span>
        </label>
        <div class="phone-box">
          <el-input placeholder="请输入您收到的验证码" v-model.trim="code" size="medium" />
          <div class="submit-button-code">
            <button type="button" @click="sendCode" :disabled="false">
              登陆/注册
            </button>
          </div>
        </div>
        <div class="need-login" @click="showTips">
          <label for="name">
            您的姓名
            <span class="data-form-required">*</span>
          </label>
          <el-input placeholder="请输入您的姓名" v-model="form.name" size="medium" :disabled="isLogin !== 1" />

          <label for="company">
            公司名称
            <span class="data-form-required" v-if="noNeed.indexOf('company') > -1">*</span>
          </label>
          <el-input placeholder="请输入您的公司名称" v-model="form.company" size="medium" :disabled="isLogin !== 1" />

          <label for="job">
            您的职位
            <span class="data-form-required" v-if="noNeed.indexOf('job') > -1">*</span>
          </label>
          <el-input placeholder="请输入您的职位" v-model="form.job" size="medium" :disabled="isLogin !== 1" />
          <label for="mail">
            Email
            <span class="data-form-required" v-if="noNeed.indexOf('mail') > -1">*</span>
          </label>
          <el-input placeholder="输入您的Email地址（使用企业邮箱通过率更高）" v-model="form.mail" size="medium" :disabled="isLogin !== 1" />

          <label for="wechat">微信号<span class="data-form-required" v-if="noNeed.indexOf('wechat') > -1">*</span></label>
          <el-input placeholder="请输入您的微信号" v-model="form.wechat" size="medium" :disabled="isLogin !== 1" />

          <label for="remark">备注
            <span class="data-form-required" v-if="noNeed.indexOf('remark') > -1">*</span></label>
          <el-input placeholder="选填：备注信息" v-model="form.remark" size="medium" :disabled="isLogin !== 1" />

          <label for="concatPerson">联络人
            <span class="data-form-required" v-if="noNeed.indexOf('concatPerson') > -1">*</span></label>
          <el-input placeholder="选填：联络人" v-model="form.concatPerson" size="medium" :disabled="isLogin !== 1" />

          <div class="carder-contanier">
            <!-- <el-upload :action="oss.host" :data='oss' :on-success='onSuccess' :on-remove='onRemove' :on-progress='onUpload' :on-error='onError' :disabled='isLogin!==1'> -->
            <el-upload action="/file/api/file/ad" :data="oss" :on-success="onSuccess" :on-remove="onRemove"
              :on-progress="onUpload" :on-error="onError">
              <img v-if="form.card" :src="form.card" class="avatar" />
              <div v-else class="el-icon-plus avatar-uploader-icon">
                上传名片
                <span class="data-form-required" v-if="noNeed.indexOf('card') > -1">*</span>
              </div>
            </el-upload>
          </div>
        </div>
      </div>

      <div class="submit-button">
        <button type="button" @click="submitData" :disabled="isLogin !== 1 && status">
          提交
        </button>
      </div>
      <!-- <div class="form-footer">
        <img src="/static/ft.jpg" alt="">
      </div>-->
    </div>
  </div>
</template>
<script>
import { Toast, Indicator, MessageBox } from "mint-ui";
import { setInterval, setTimeout } from "timers";
import axios from "axios";
export default {
  data() {
    return {
      summary: null,
      cityList: [],
      nowCity: {},
      phoneCode: "",
      code: "",
      noNeed: [],
      form: {
        acType: "enroll",
        acId: null,
        city: null,
        job: null,
        company: null,
        name: null,
        mail: null,
        card: null,
        wechat: null,
        phone: "",
        phoneCode: "86",
        remark: ""
      },
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signatrue: "",
        host: "",
        success_action_status: 200,
        callback: ""
      },
      header: null,
      status: null,
      randomKey: null,
      onUploading: null,
      isSendCode: 0,
      isLogin: 0,
      reTime: 61,
      setInTime: null,
      city: "",
      acId: "",
      checkCode: {
        challenge: "",
        geetestId: "",
        success: ""
      }
    };
  },
  computed: {},
  methods: {
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    onSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.card = res.result.url;
        Indicator.close();
      }
    },
    onRemove(res, file, filelist) {
      this.form.card = null;
    },
    onUpload(event, file, fileList) {
      Indicator.open("努力上传中...");
    },
    onError(err, file, fileList) {
      Toast("上传出错..." + err);
    },
    submitData() {
      for (let key in this.form) {
        // if (key !== "remark") {
        //   if (key !== "id") {
        //     if (key !== "hkstockPing") {
        //       if (key !== "uniqueCode") {
        //         if (key !== "property") {
        //           if (!this.form[key] === true) {
        //             console.log(key, this.form[key]);
        //             Toast({
        //               message: "报名信息不全~",
        //               iconClass: "icon el-icon-warning"
        //             });
        //             return false;
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
        let endNoNeed = [
          "acType",
          "acId",
          "name",
          "phone",
          "phoneCode",
          ...this.noNeed
        ];
        if (endNoNeed.indexOf(key) > -1) {
          if (!this.form[key] === true) {
            console.log(key, this.form[key]);
            Toast({
              message: "报名信息不全~",
              iconClass: "icon el-icon-warning"
            });
            return false;
          }
        }
      }
      this.$http
        .add_user({
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            //首次报名报名
            Toast({
              message: "已报名成功!请留意后续资料审核通知",
              iconClass: "icon el-icon-success",
              duration: 5000
            });
            setTimeout(() => {
              window.location.replace("http://www.gelonghui.com");
            }, 3000);
          } else if (res.data.statusCode === 203) {
            //重复报名
            Toast({
              message: res.data.message,
              iconClass: "icon el-icon-success",
              duration: 5000
            });
          } else {
            Toast({
              message: res.data.message,
              iconClass: "icon el-icon-warning",
              duration: 5000
            });
          }
        });
    },
    gtPost() {
      if (this.form.phone.length !== 11 && this.form.phone.length !== 8) {
        Toast({
          message: "请输入8位香港手机号,或者11位大陆手机号~",
          iconClass: "icon el-icon-warning"
        });
        return;
      }
      let phone = this.form.phone;
      let countryCode = phone.length === 11 ? "86" : "852";
      this.form.phoneCode = countryCode;
      axios({
        url: "/api/over-sea-sms/gt-init",
        method: "post",
        // `headers` are custom headers to be sent
        headers: { platform: "web" },
        data: {
          phone,
          countryCode
        }
      }).then(res => {
        this.checkCode = res.data.result;
        this.initGeetestBehover();
      });
    },
    initGeetestBehover() {
      let _this = this;
      initGeetest(
        {
          // 以下配置参数来自服务端
          gt: _this.checkCode.gt,
          challenge: _this.checkCode.challenge,
          offline: !_this.checkCode.success,
          new_captcha: true,
          width: "100%",
          product: "bind",
          lang: "zh-cn"
        },
        function (captchaObj) {
          // 这里可以调用验证实例 captchaObj 的实例方法
          captchaObj.onReady(() => {
            console.log("start captcha content");
            captchaObj.verify();
            captchaObj.onSuccess(() => {
              const result = captchaObj.getValidate();
              console.log("获取到的用户行为参数", result);
              const challenge = result.geetest_challenge;
              const validate = result.geetest_validate;
              const seccode = result.geetest_seccode;

              // 带上之前的验证的参数激活getPhoneCode 重新获取验证码
              _this.getCode(challenge, validate, seccode);
            });

            captchaObj.onError(() => {
              // console.log('失败')
              captchaObj.reset(); // 调用该接口进行重置
            });
            captchaObj.onClose(() => {
              // console.log('关闭')
            });
          });
          // captchaObj.appendTo('#captcha-box');
          // _this.captchaObj = captchaObj
        }
      );
    },
    getCode(challenge, validate, seccode) {
      this.$http.check_user_history_info(this.form.phone).then(res => {
        if (res.data.statusCode === 200 && res.data.message !== 0) {
          Object.assign(this.form, res.data.result);
          this.form.acType = "enroll";
          this.form.acId = this.acId;
          this.form.city = this.city;
          this.form.id = "";
          this.form.property = "";
          this.form.concatPerson = "";
          this.form.hkstockPing = "";
        } else {
          this.form.acType = "enroll";
          this.form.acId = this.acId;
          this.form.city = this.city;
          this.form.property = "";
          this.form.concatPerson = "";
          this.form.hkstockPing = "";
        }
      });
      this.$http
        .phone_get_code_glh({
          countryCode: this.form.phoneCode,
          phone: this.form.phone,
          challenge,
          validate,
          seccode
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.isSendCode = 1;

            this.recuTime();
          } else {
            Toast({
              message: "请检查您的网络后重新发送验证码~",
              iconClass: "icon el-icon-warning"
            });
          }
        });
    },
    sendCode() {
      let phone = this.form.phone.toString();
      let countryCode = phone.length === 11 ? "86" : "852";
      let phoneCode = this.code;
      this.$http
        .send_phone_code_glh({
          countryCode,
          phone,
          phoneCode
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            let nowTime = parseInt(new Date().getTime() / 1000);
            let createDate = res.data.result.createDate;
            this.isLogin = 1;
            this.isSendCode = 4;
            if (nowTime - createDate > 50) {
              Toast({
                message: `登陆成功~欢迎您${res.data.result.user.nickname}~`,
                iconClass: "icon el-icon-success"
              });
            } else {
              Toast({
                message: `注册成功~欢迎您${res.data.result.user.userId
                  }号会员,请尽快登陆格隆汇App补充您的个人信息~`,
                iconClass: "icon el-icon-success"
              });
            }
          } else {
            Toast({
              message: `验证码错误，请您输入正确的验证码~`,
              iconClass: "icon el-icon-warning"
            });
          }
        });
    },
    recuTime() {
      this.reTime = 60;
      clearInterval(this.setInTime);
      this.setInTime = setInterval(() => {
        this.reTime--;
        if (this.reTime < 0) {
          this.isSendCode = 2;
        }
      }, 1000);
    },
    getData() {
      let id = this.$route.params.id;
      this.$http.getEnrollDetail(id).then(res => {
        let active = res.data.result;
        // TODO: 这里添加头部图片
        this.header = active.head;
        this.city = active.city;
        this.acId = active.id;
        this.summary = active.summary;
        this.noNeed = active.noNeed ? active.noNeed.split(",") : [];
        window.document.title = active.title;
        this.status = active.status;
        if (!active.status) {
          Toast({
            message: "活动已结束~",
            iconClass: "icon el-icon-warning"
          });
        }
      });
    },
    showTips() {
      if (this.isLogin !== 1) {
        Toast({
          message: "请先点击 登陆/注册 按钮~",
        })
      }
    }
  },
  mounted() {
    this.getOssSign();

    this.getData();
  }
};
</script>
<style scoped>
.is-company .el-radio {
  display: inline-block;
}

.choose-phoneCode {
  width: 20%;
}

.carder-contanier {
  overflow: hidden;
  width: 300px;
  height: 150px;
  margin: 10px auto;
}

.el-upload {
  width: 300px;
  display: block;
}

.carder-contanier div,
.carder-contanier img {
  background: #cccccc;
  width: 300px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}

.submit-form-container {
  /* background: url(https://asset.mikecrm.com/getimg/origin/images/formTemplate/img-bmsq-0-0.jpg)
    repeat; */
  height: auto;
  display: block;
  width: 100%;
  position: absolute;
  font-size: 14px;
}

.form-informations {
  max-width: 560px;
  width: 100%;
  background: #fff;
  margin: 0 auto;
}

.form-header h1,
.form-header p {
  color: rgb(255, 255, 255);
  font-family: 微软雅黑;
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
  text-shadow: rgba(0, 0, 0, 0.2) 0px 2px 2px;
  text-align: center;
}

.form-header img {
  width: 100%;
  height: auto;
  display: block;
}

.city-position {
  text-align: center;
  font-size: 12px;
  padding: 20px 0;
}

.data-form {
  padding: 15px;
  overflow: hidden;
}

.data-form label {
  display: block;
  padding: 5px 0;
}

.data-form input {
  width: 96%;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  height: 26px;
  line-height: 26px;
  margin-top: 6px;
}

.data-form-required {
  color: red;
}

.submit-button {
  padding: 15px;
}

.submit-button button {
  background: dodgerblue;
  color: #fff;
  width: 100%;
  border-radius: 5px;
  border: 0px;
  line-height: 30px;
}

.phone-box {
  display: flex;
  position: relative;
}

.submit-button-phone,
.submit-button-code {
  position: absolute;
  /* width: 70px; */
  height: 36px;
  right: 0;
  top: 0;
}

.submit-button-phone button,
.submit-button-code button {
  /* margin: 0 3px; */
  background-color: rgb(73, 164, 255);
  width: 80px;
  color: rgb(255, 255, 255);
  border-radius: 4px;
  border: 0px;
  height: 36px;
  line-height: 30px;
  border: 1px solid #dcdfe6;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-footer img {
  width: 100%;
  height: auto;
  display: block;
}

.data-time-count {
  padding: 0 15px;
  overflow: hidden;
}

.data-time-count ul li {
  margin: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  text-align: center;
  width: 40%;
  float: left;
  cursor: pointer;
  font-size: 14px;
  margin-right: 10px;
  list-style: none;
}

.meeting-contact h3 {
  border-bottom: 1px solid #666;
  font-weight: 700;
  font-size: 14px;
  line-height: 30px;
  margin: 10px 20px;
}

.contact-info {
  padding: 0 15px;
}

.contact-info>>>p {
  color: #696969;
  font-size: 14px;
  line-height: 30px;
  margin: 10px 0;
}

.city-list {
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-size: 12px;
  flex-wrap: wrap;
  margin-top: 5px;
  margin-bottom: 10px;
}

.botton {
  padding: 5px;
  border: 1px solid rgb(126, 126, 126);
  cursor: pointer;
  border-radius: 3px;
}

.botton-active {
  background-color: dodgerblue;
  color: #fff;
}

.botton-over {
  background-color: #b6b6b6;
  color: rgb(0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/frontend/enroll.vue